import { DsmResourceLink } from "./DsmResourceLink";
import type { DsmForeignResourceType } from "./types";

export function renderForeignResource(
  uuid: string,
  resourceType: DsmForeignResourceType,
) {
  return <DsmResourceLink resourceType={resourceType} uuid={uuid} />;
}
